import { render } from "./PalliativeDeathRecord.vue?vue&type=template&id=285897c2&scoped=true"
import script from "./PalliativeDeathRecord.vue?vue&type=script&lang=js"
export * from "./PalliativeDeathRecord.vue?vue&type=script&lang=js"

import "./PalliativeDeathRecord.vue?vue&type=style&index=0&id=285897c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285897c2"]])

export default __exports__